import { render, staticRenderFns } from "./ConfirmPaymentSetting.pug?vue&type=template&id=c67383de&lang=pug&"
import script from "./ConfirmPaymentSetting.vue?vue&type=script&lang=js&"
export * from "./ConfirmPaymentSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports